import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { IconButton, Tooltip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { useToast } from 'use-toast-mui';
import { setFavorite } from '../../api/favorite';
import { errorMessages } from '../../utils/methods';

const STAR_COLOR = '#FFB300';
const EMPTY_COLOR = '#C4C4C4';

/**
 * 지점 공용 즐겨찾기 별표. 목록 행(Link) 안에 두어도 클릭이 행으로 번지지 않는다.
 * - targetType: api/favorite.js 의 FAVORITE_TARGET 값
 * - onChanged(nextFavorite): 서버 반영 후 호출 — 목록을 다시 불러 즐겨찾기 우선 정렬을 맞추는 용도
 */
export default function FavoriteStar({ targetType, targetId, favorite, onChanged, size = 'small' }) {
  const user = useSelector(state => state.user.user);
  const toast = useToast();
  const [saving, setSaving] = useState(false);
  const branchId = user?.branch?.branchId;

  const handleClick = async e => {
    e.preventDefault();
    e.stopPropagation();
    if (saving) return;
    if (!branchId) {
      toast.warning('지점을 선택해 주세요');
      return;
    }
    setSaving(true);
    try {
      const res = await setFavorite(user.token, { branchId, targetType, targetId, favorite: !favorite });
      onChanged?.(res?.favorite ?? !favorite);
    } catch (error) {
      toast.error(errorMessages(error));
    } finally {
      setSaving(false);
    }
  };

  // disabled 를 쓰지 않는다 — MUI disabled 버튼은 pointer-events:none 이라 저장 중 클릭이
  // 행(Link)으로 새어 상세로 이동한다(연타 실측). 저장 중 클릭은 handleClick 에서 무시한다.
  return (
    <Tooltip title={favorite ? '즐겨찾기 해제' : '즐겨찾기'} arrow>
      <IconButton size={size} onClick={handleClick} sx={{ p: '4px' }}>
        {favorite ? <StarIcon sx={{ color: STAR_COLOR }} /> : <StarBorderIcon sx={{ color: EMPTY_COLOR }} />}
      </IconButton>
    </Tooltip>
  );
}
